import fileIconUrl from '../../assets/file_icon.svg';

type PdfLinkProps = {
  label: string;
  href: string;
};

const PdfLink = ({ label, href }: PdfLinkProps) => {
  return (
    <div className="w-fit hover:underline">
      <a href={href} className="text-xs text-axaBlue items-center font-sans flex" target="_blank" rel="noreferrer">
        <span className="text-lg no-underline">{label}</span>
        <img src={fileIconUrl} alt="Adobe PDF Icon" className="h-4 ml-1" />
      </a>
    </div>
  );
};

export default PdfLink;
